import { z } from "zod";
// Only allow letters, spaces, and common punctuation in address
const alphaRegex = /^[A-Za-z\s,.'-]+$/;
const alphanumericRegex = /^[A-Za-z0-9\s,.'-]+$/;

// Function that creates schema with localized messages
export const createBranchSchema = (t: (key: string, options?: any) => string) => {
  return z.object({
    branchName: z
      .string()
      .min(3, t("shared.branchForm.minLength", { min: 3 }))
      .max(50, t("shared.branchForm.maxLength", { max: 50 }))
      .regex(alphanumericRegex, t("shared.branchForm.invalidAlphaNumeric")),

    city: z.string().min(1, t("shared.branchForm.required")),
    district: z.string().min(1, t("shared.branchForm.required")),
    
    address: z
      .string()
      .min(1, t("shared.branchForm.required"))
      .min(10, t("shared.branchForm.minLengthAddress", { min: 10 }))
      .max(100, "Address cannot exceed 100 characters")
      .regex(alphanumericRegex, t("shared.branchForm.invalidAlphaNumeric")),
    contactFirstName: z
      .string()
      .min(1, t("shared.branchForm.required"))
      .max(15, "First name cannot exceed 15 characters")
      .regex(alphaRegex, t("shared.branchForm.invalidBranchName")),
    contactLastName: z
      .string()
      .min(1, t("shared.branchForm.required"))
      .max(15, "Last name cannot exceed 15 characters")
      .regex(alphaRegex, t("shared.branchForm.invalidBranchName")),
    contactEmail: z
      .string()
      .max(50, "Email cannot exceed 50 characters")
      .refine((val) => {
        // If no value provided, it's valid (optional field)
        if (!val || val.trim() === '') return true;
        
        // If value provided, validate it's a proper email
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(val);
      }, {
        message: t("shared.branchForm.invalidEmail")
      }),
    country: z.string(),
    phone: z.string().optional(),
  });
};

export type BranchFormValues = z.infer<ReturnType<typeof createBranchSchema>>;

export const defaultValues: BranchFormValues = {
  branchName: "",
  city: "",
  district: "",
  address: "",
  contactFirstName: "",
  contactLastName: "",
  contactEmail: "",
  country: "SA",
  phone: "",
};